import ChartPreview from './ChartPreview';

export default ChartPreview;
